import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http'
import {inject} from '@angular/core'
import {ICollectResult} from '@vambie/vambie-bankid-gw'
import {first, Observable, switchMap} from 'rxjs'
import {ConfigService} from '../services/config.service'

/**
 * Intercept all requests and add auth token. We should however
 * do this only on white listed requests so that we do not
 * send our tokens when not needed. In its simplest form this
 * assumes that all outgoing requests after the token is set
 * should have it.
 */

const AUTH_PATHS = [
  '/api/',
  '/service/self',
  '/service/logout',
  '/swish',
  '/admin/'
]
export const authInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {

  const configService = inject(ConfigService)
  const auth = AUTH_PATHS.reduce((acc: boolean, path: string) => {
    return acc || req.url.includes(path)
  }, false)

  if (auth) {
    return configService.accessToken$.pipe(
      first(),
      switchMap((token: ICollectResult | null) => {
        // Only send authorization bearer if endpoint is relevant
        const authReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token!.accessToken}`)
        })
        return next(authReq)
      })
    )
  } else {
    return next(req)
  }
}
